<!-- 订单详情组件 -->
<template>
  <div>
    <div class="product-content" v-if='orderGetter && orderGetter.subscription'>
      <!-- 订阅首购情况 -->
      <div v-if="isSubscriptionFirstPurchase">
        <!-- 场景二：有优惠 -->
        <div class="product-header">
          <!-- 第一行：Subscribe to {productName} -->
          <div class="amountWord">{{ $t('message.checkout.subscribeTo') }} {{ orderGetter && orderGetter.subscription.productName }}</div>
          <div class="product-flex" style="margin-top: 6px;align-items: flex-end !important;">
            <div class="amountNum">
              {{ orderGetter && formatAmount(orderGetter.txnAmount) }}
              {{ orderGetter && orderGetter.txnCurrency }}
            </div>
            <div class="amountIcon" @click="showDetail()"
              v-if="viewTxnId !== false || (orderGetter && orderGetter.website && !orderGetter.hideWebsite)">{{
                showWord
              }} <span :class="[showDetails ? 'el-icon-arrow-up' : 'el-icon-arrow-down']"></span>
            </div>
          </div>
          <!-- 第二行：per {frequency} for {count} payments, Then {amount} {currency} per {frequency} -->
          <div class="amountWord" style="margin-top: 6px;">
            {{ formatSubscriptionFrequency(orderGetter.subscription.frequencyType, orderGetter.subscription.frequencyPoint) }}
            {{ $tc('message.checkout.forPayments', Number(orderGetter.subscription.amountOffCycleCount), { X: orderGetter.subscription.amountOffCycleCount }) }},
            {{ $t('message.checkout.then') }} {{ getOriginalAmount() }} {{ orderGetter.txnCurrency }}
            {{ formatSubscriptionFrequency(orderGetter.subscription.frequencyType, orderGetter.subscription.frequencyPoint) }}
          </div>
        </div>
        <div v-if="showDetails" class="product-details">
          <div v-if="viewTxnId !== false" style="margin-bottom: 18px;">
            <div class="label">{{ $t('message.checkout.orderno') }}</div>
            <div class="label-detail">{{ orderGetter && orderGetter.merchantTxnId }}</div>
          </div>
          <div v-if="orderGetter && orderGetter.website && !orderGetter.hideWebsite">
            <div class="label">{{ $t('message.checkout.website') }}</div>
            <div class="label-detail">{{ orderGetter && orderGetter.website }}</div>
          </div>
        </div>
      </div>
      <!-- 有订阅情况 -->
      <div v-else>
        <div class="product-header">
          <div class="amountWord">{{ $t('message.checkout.subscribeTo') }} {{ orderGetter &&
            orderGetter.subscription.productName }}</div>
          <!-- <div class="amountWord">{{ $t('message.checkout.amount') }}:</div> -->
          <!-- 有试用信息 -->
          <div class="hasFree" v-if="orderGetter && orderGetter.subscription.trialDays">
            <!-- 第一行：{trialDays} days free -->
            <div class="amountNum" style="margin-top: 6px;">
              {{ $t('message.checkout.daysFree', { X: orderGetter.subscription.trialDays }) }}
            </div>
            <!-- 第二行：Then {amount} {currency} per {frequency} -->
            <div class="product-flex">
              <div class="amountWord">
                {{ $t('message.checkout.then') }} {{ orderGetter && formatAmount(orderGetter.txnAmount) }} {{ orderGetter && orderGetter.txnCurrency }}
                {{ formatSubscriptionFrequency(orderGetter.subscription.frequencyType, orderGetter.subscription.frequencyPoint) }}
              </div>
              <div class="amountIcon" @click="showDetail()"
                v-if="viewTxnId !== false || (orderGetter && orderGetter.website && !orderGetter.hideWebsite)">{{
                  showWord
                }} <span :class="[showDetails ? 'el-icon-arrow-up' : 'el-icon-arrow-down']"></span>
              </div>
            </div>
          </div>
          <!-- 无订阅试用 -->
          <div v-else>
            <div class="amountNum" style="margin-top: 6px;">{{ orderGetter &&
              formatAmount(orderGetter.txnAmount) }} {{ orderGetter && orderGetter.txnCurrency }}</div>
            <div class="product-flex">
              <div class="amountWord">
                {{ formatSubscriptionFrequency(orderGetter.subscription.frequencyType, orderGetter.subscription.frequencyPoint)
                }}
              </div>
              <div class="amountIcon" @click="showDetail()"
                v-if="viewTxnId !== false || (orderGetter && orderGetter.website && !orderGetter.hideWebsite)">{{
                  $t('message.checkout.details') }} <span
                  :class="[showDetails ? 'el-icon-arrow-up' : 'el-icon-arrow-down']"></span>
              </div>
            </div>
          </div>
        </div>
        <div v-if="showDetails" class="product-details">
          <div v-if="viewTxnId !== false" style="margin-bottom: 18px;">
            <div class="label">{{ $t('message.checkout.orderno') }}</div>
            <div class="label-detail">{{ orderGetter && orderGetter.merchantTxnId }}</div>
          </div>
          <div v-if="orderGetter && orderGetter.website && !orderGetter.hideWebsite">
            <div class="label">{{ $t('message.checkout.website') }}</div>
            <div class="label-detail">{{ orderGetter && orderGetter.website }}</div>
          </div>
        </div>
      </div>
    </div>
    <!-- 无订阅 -->
    <div v-else class="product-content">
      <div
        :style="{ backgroundColor: isFormatAmount ? '#fff' : '#f9f9f9', borderRadius: isFormatAmount ? '8px' : '0' }">
        <div class="product-header">
          <div class="amountWord">{{ $t('message.checkout.amount') }}</div>
          <div class="product-flex" style="margin-top: 6px;align-items: flex-end !important;">
            <div class="amountNum"> {{ orderGetter &&
              formatAmount(orderGetter.txnAmount) }} {{ orderGetter && orderGetter.txnCurrency }}

              <el-button class="button" type="text" @click="copyTicket" v-if="isFormatAmount">
                <span class="iconfont icon-rongqi"></span>
              </el-button>

            </div>
            <div class="amountIcon" @click="showDetail()" v-if="(viewTxnId !== false || !orderGetter?.hideWebsite)">{{
              showWord }} <span :class="[showDetails ? 'el-icon-arrow-up' : 'el-icon-arrow-down']"></span>
            </div>
          </div>
        </div>
        <div v-if="showDetails" class="product-details">
          <div v-if="viewTxnId !== false">
            <div class="label">{{ $t('message.checkout.orderno') }}</div>
            <div class="label-detail">{{ orderGetter && orderGetter.merchantTxnId }}</div>
          </div>
          <div style="margin-top: 18px;" v-if="orderGetter && orderGetter.website && !orderGetter.hideWebsite">
            <div class="label">{{ $t('message.checkout.website') }}</div>
            <div class="label-detail">{{ orderGetter && orderGetter.website }}</div>
          </div>
        </div>
      </div>

    </div>
  </div>
</template>
<script>
import { formatLocalizedAmount, formatSubscriptionFrequency } from '@/utils/tools/format';
import { copyString } from '@/utils/tools/utils';

export default {
  name: 'orderSummary',
  computed: {
    // 判断是否为订阅首购
    isSubscriptionFirstPurchase() {
      return this.orderGetter?.subscription?.amountOff !== null &&
        this.orderGetter?.subscription?.amountOff !== undefined;
    },
  },
  props: {
    orderGetter: {
      type: Object,
      default: null,
    },
    viewTxnId: {
      type: Boolean,
      default: true,
    },
    // 额外定制样式 适用于qr
    isFormatAmount: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      showDetails: false,
      showWord: this.$t('message.checkout.details'),
    };
  },
  methods: {
    formatSubscriptionFrequency,
    /**
     * 统一的金额格式化方法
     * @param {number|string} amount - 需要格式化的金额
     * @returns {string} - 格式化后的金额
     * @author Nemo
     */
    formatAmount(amount) {
      return formatLocalizedAmount(amount, this.orderGetter?.txnCurrency, this.orderGetter?.paymentCountry);
    },
    showDetail() {
      this.showDetails = !this.showDetails;
      if (this.showDetails) {
        this.showWord = this.$t('message.checkout.fold');
      } else {
        this.showWord = this.$t('message.checkout.details');
      }
    },
    copyTicket() {
      copyString(this.orderGetter.txnAmount);
    },
    // 获取原始金额（优惠前）
    getOriginalAmount() {
      const orderAmount = this.orderGetter?.subscription?.orderAmount || 0;
      return this.formatAmount(orderAmount);
    },
  },
};
</script>
<style lang="scss" scoped>
.product-content {
  padding: 0px 16px;
  box-sizing: border-box;
  // margin-bottom: 18px;

  // background-color: #F9F9F9;
  >div {
    border-radius: 8px 8px 8px 8px;
    background-color: #F9F9F9;
  }

  .product-header {
    padding: 16px;
    box-sizing: border-box;

    .amountWord {
      font-weight: 400;
      font-size: 14px;
      color: #667085;
      line-height: 18px;
      text-align: left;
    }

    .product-flex {
      display: flex;
      justify-content: space-between;
      margin-top: 6px;
      align-items: center;

      .amountNum {
        font-size: 32px;
        color: #1A202C;
        line-height: 40px;
        text-align: left;
        font-weight: 600;

      }

      .amountIcon {
        font-size: 12px;
        color: #8D98AF;
        line-height: 22px;
        text-align: right;
        font-style: normal;
        position: relative;
        // bottom: 5px;
      }
    }
  }

  .product-details {
    padding: 8px 16px 16px;
    box-sizing: border-box;

    >div {
      display: flex;
      justify-content: space-between;

      .label {
        font-size: 14px;
        color: #667085;
        line-height: 18px;
        font-family: "Open Sans regular";

      }

      .label-detail {
        font-weight: 400;
        font-size: 14px;
        color: #1A202C;
        line-height: 18px;
        text-align: right;
        font-family: "Open Sans regular";
        word-wrap: break-word;
        overflow-wrap: break-word;
        word-break: break-all;
        width: 206px;

      }
    }

  }

  .amountNum {
    font-size: 32px;
    color: #1A202C;
    line-height: 40px;
    text-align: left;
    font-weight: 600;
  }
}
</style>
